<template>

    <cms-view>

        <cms-heading title="Acties" icon="entypo-flag">
            <cms-button :disabled="!hasFilter" @click="resetFilters">Reset filters</cms-button>
            <div class="cms-segmented-control">
                <cms-button :class="{ active: viewMode === 'LIST' }" @click="viewMode = 'LIST'">Lijst</cms-button>
                <cms-button :class="{ active: viewMode === 'MAP' }" @click="viewMode = 'MAP'">Kaart</cms-button>
            </div>
        </cms-heading>

        <complex-filter-panel :options="filterOptions" v-model="filter"></complex-filter-panel>

        <keep-alive>
            <actions-list v-if="viewMode === 'LIST'" :filter="filter" @update-state="updateState" ref="actionList"></actions-list>
            <actions-map v-if="viewMode === 'MAP'" :filter="filter" @update-state="updateState" ref="actionMap"></actions-map>
        </keep-alive>

    </cms-view>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'

    import ActionState from 'app/enums/ActionState'
    import actionStateFilter from 'app/filters/actionState'
    import numberFilter from '@wittignl/js-core/filters/number'

    import ActionsList from "app/components/routes/action/ActionsList.vue";
    import ActionsMap from "app/components/routes/action/ActionsMap.vue";
    import ActionMutations from "app/mutations/ActionMutations";

    const ViewMode = {
        LIST: 'LIST',
        MAP: 'MAP'
    }

    @Component({

        name: 'actions',
        components: { ActionsList, ActionsMap }
    })
    export default class Actions extends Vue
    {
        static FILTER_STORAGE_KEY = "ActionsFilter";
        static VIEW_MODE_STORAGE_KEY = "ActionsViewMode";

        data(){

            return {

                viewMode: this.$storage.getSession(Actions.VIEW_MODE_STORAGE_KEY, ViewMode.LIST),
                projects: {},
                loading: 0,

                filter: this.$storage.getSession(Actions.FILTER_STORAGE_KEY, {}),
            }
        }

        created(){

            this.$watch('filter', (filter) => this.$storage.setSession(Actions.FILTER_STORAGE_KEY, filter));
            this.$watch('viewMode', (mode) => this.$storage.setSession(Actions.VIEW_MODE_STORAGE_KEY, mode));
        }

        breadcrumb(){

            return 'Acties';
        }

        resetFilters(){

            this.filter = {};
        }

        async updateState({ state, filter, actionCount, actionIds, sortField, sortDirection }){

            const count = Math.min(actionIds ? actionIds.length : actionCount, 25);

            const { result, modal } = await this.$alert.confirm('Weet je zeker dat je de status wilt wijzigen?', true, {
                subtitle: `De status van ${numberFilter(count, 0)} acties zal worden gewijzigd naar '${actionStateFilter(state)}'`
            });

            if(!result) {
                return;
            }

            try {

                await ActionMutations.bulkUpdateState(state, filter, sortField, sortDirection, actionIds);

                this.$toast.success('De status is gewijzigd');

                if(this.$refs.actionList){
                    this.$refs.actionList.refetch();
                }

                if(this.$refs.actionMap){
                    this.$refs.actionMap.refetch();
                }
            }
            catch(e){

                this.logger.error('Error bulk updating action status', e);
                this.$toast.error('De status kon niet worden gewijzigd');
            }

            this.$modal.close(modal);
        }

        get hasFilter(){

            return Object.keys(this.filter).length > 0;
        }

        onQueryError(error){

            this.$logger.error(error);
            this.$toast.error('De gegevens konden niet worden opgehaald');
        }

        get filterOptions(){

            return [
                {
                    title: 'Status',
                    key: 'state',
                    options: ActionState.options()
                },
                {
                    title: 'Projectcode',
                    key: 'projectCode',
                    type: 'string'
                },
                {
                    title: 'Afhandelingstermijn',
                    key: 'deadline',
                    type: 'number'
                },
                {
                    title: 'Deadline',
                    key: 'deadlineDate',
                    type: 'date'
                }
            ];
        }
    }

</script>
